import { useCallback, useEffect, useRef, useState } from "react";
import socketService from "../services/socketService";
import { useDispatch } from "react-redux";
import { kitchenHandler } from "../redux/handlers";
export function useOrderSocket() {
  const orderIdRef = useRef(null);
  const [lastMessage, setLastMessage] = useState(null);
  const dispatch = useDispatch();
  const connect = useCallback(
    (posId) => {
      if (!posId) return;
      orderIdRef.current = posId;
      if (!socketService.socket) {
        socketService.connect();
      }
      socketService.setOrderChannel(posId);
      console.log("เริ่มต้นการตรวจสอบ Order จาก server : ", posId);

      const updateFromOrderChannel = socketService.registerOrderHandler((msg) => {
        setLastMessage(msg);
        dispatch(kitchenHandler.handleSocketResponse(msg, true));
      });
      return updateFromOrderChannel;
    },
    [dispatch]
  );

  const disconnect = useCallback(() => {
    if (orderIdRef.current) {
      console.log("Disconnecting from order:", orderIdRef.current);
      orderIdRef.current = null;
    }
  }, []);

  return { connect, disconnect, lastMessage };
}
